var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageNotAvailableXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 65,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.431373 0 0 0 0 0.431373 0 0 0 0 0.431373 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.03)",
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#5B6770",
    strokeWidth: 1.35
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.4,
    cy: 30.4,
    r: 29.804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.344 52.276a22.651 22.651 0 0 1-15.82-15.82 1.419 1.419 0 0 1 1.359-1.8h7.534c.575.008 1.088.36 1.3.894a12.84 12.84 0 0 0 6.533 6.533c.533.212.886.725.894 1.3v7.534a1.419 1.419 0 0 1-1.8 1.36zM10.372 25.62a1.395 1.395 0 0 1-1.717-1.777 22.651 22.651 0 0 1 43.49 0 1.395 1.395 0 0 1-1.717 1.729A80.16 80.16 0 0 0 30.4 23.259a80.16 80.16 0 0 0-20.028 2.36zM34.656 50.917v-7.534c.008-.575.36-1.088.894-1.3a12.84 12.84 0 0 0 6.533-6.533 1.419 1.419 0 0 1 1.3-.894h7.534a1.419 1.419 0 0 1 1.36 1.8 22.651 22.651 0 0 1-15.82 15.82 1.419 1.419 0 0 1-1.801-1.359z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotAvailableXs);
export default __webpack_public_path__ + "static/media/image-not-available-xs.e235ca36f1a580d657a568c0682f4bbd.svg";
export { ForwardRef as ReactComponent };